import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";

function Technical() {
    const { plantName, id: cogen_id } = useParams(); // ✅ Now correctly receives both
    const [technicalData, setTechnicalData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        const fetchTechnicalInfo = async () => {
            try {
                const res = await axios.get(
                    `https://backend-zkgn.onrender.com/api/cogen_technical/${cogen_id}`
                );

                if (res.data && Object.keys(res.data).length > 0) {
                    setTechnicalData(res.data);
                } else {
                    setTechnicalData(null);
                }
            } catch (err) {
                console.error("Error fetching technical data:", err.message);
                setError("Failed to load technical data. Please try again later.");
            } finally {
                setLoading(false);
            }
        };

        fetchTechnicalInfo();
    }, [cogen_id]);

    const handleDelete = async () => {
        if (!technicalData?.tech_id) return;

        if (!window.confirm("Are you sure you want to delete this technical information?")) return;

        try {
            await axios.delete(
                `https://backend-zkgn.onrender.com/api/cogen_technical/${technicalData.tech_id}`
            );
            alert("Technical information deleted successfully!");
            setTechnicalData(null);
        } catch (err) {
            console.error("Error deleting technical info:", err.message);
            alert("Failed to delete technical information.");
        }
    };

    if (loading) return <div>Loading technical info...</div>;
    if (error) return <div className="text-danger">{error}</div>;

    return (
        <div className="container-fluid my-5">
            <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap">
                <h4 className="fw-bold text-tertiary mb-2">Technical Information</h4>

                {/* ADD BUTTON */}
                {!technicalData && (
                    <Link
                        to={`/add-technical/${plantName}/${cogen_id}`}
                        className="btn btn-primary"
                    >
                        Add Technical Information
                    </Link>
                )}
            </div>

            {!technicalData ? (
                <div>No technical information found for this plant.</div>
            ) : (
                <div className="table-responsive">
                    <table className="table table-bordered align-middle">
                        <tbody>
                            <tr><th>Boiler Make</th><td>{technicalData.boiler_make}</td></tr>
                            <tr><th>Boiler Capacity</th><td>{technicalData.boiler_capacity}</td></tr>
                            <tr><th>Furnace Type</th><td>{technicalData.furnes_type}</td></tr>
                            <tr><th>Fuel</th><td>{technicalData.fuel}</td></tr>
                            <tr><th>Turbine Make</th><td>{technicalData.turbine_make}</td></tr>
                            <tr><th>Turbine Capacity</th><td>{technicalData.turbine_capacity}</td></tr>
                            <tr><th>Cogen Expansion</th><td>{technicalData.cogen_expansion}</td></tr>
                            <tr><th>Cogen Capacity</th><td>{technicalData.cogen_capacity}</td></tr>
                            <tr><th>Plant Make</th><td>{technicalData.cogen_plant_make}</td></tr>

                            <tr>
                                <td colSpan="2" className="text-end">
                                    <Link
                                        to={`/edit-technical/${plantName}/${technicalData.tech_id}/${cogen_id}`}
                                        className="btn btn-link text-success me-3 p-0"
                                    >
                                        <i className="fa fa-edit"></i>
                                    </Link>

                                    <button
                                        onClick={handleDelete}
                                        className="btn btn-link text-danger p-0"
                                    >
                                        <i className="fa fa-trash"></i>
                                    </button>
                                </td>
                            </tr>

                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
}

export default Technical;
